<template>
  <div class="content" ref="container" :style="{'margin-top':top_margin+45 + 'px'}">
    <van-nav-bar :border='false' :style="{'margin-top':top_margin + 'px'}">
      <img slot="left" class="homemem" :src="img.lexus" @click="goMy()">
      <img slot="title" class="navbartitle" :src="img.navstudy">
      <img slot="right" @click="PopupShow" class="homewrite" :src="img.write">
    </van-nav-bar>
    <van-sticky :offset-top="sicky_Height">
      <van-tabs v-model="media_column_index" title-active-color='#3A3A3A' title-inactive-color="#9a9a9a" color="#3A3A3A" @click="changeChannel" sticky>
        <van-tab v-for="item in channel" :key="'channel_' + item.id" :title="item.title"></van-tab>
        <img class="imgwear" :src="img.wear" :style="{'top':top_margin+48 + 'px'}">
      </van-tabs>
    </van-sticky>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list
      v-model="loading"
      :finished="finished"
      finished-text="已加载全部"
      @load="onLoad"
      >
      <div slot="loading" class="list-loading">
        <img :src="img.loading" />
      </div>
      <div v-for="item in list" :key="'list_' + item.id">
        <div class="list-box" v-if="item.topic_info.length==0&&params.media_column_id==0">
          <div v-if="item.module.id==1">
            <div class="topichei" v-if="item.topic_info.id&&params.media_column_id>0" @click="binTopic(item.topic_info.id)">
              <img  class="topicpic" :src="item.topic_info.pic_url">
              <div class="picount">
                <div class="f-14">话题</div>
                <van-divider />
                <div class="f-16 mt-10 f-w">#{{item.topic_info.name}}#</div>
              </div>
            </div>
            <div class="leftright">
              <van-row gutter="20" v-if="item.topic_info.length==0" @click="lexusPost(1,item.id)">
                <van-col span="10">
                  <img class="picone" v-lazy="item.pic_url">
                </van-col>
                <van-col span="14" >
                  <h3 class="ellipsis-3"><van-tag class="mr-10" v-if="item.label!=null" color="#F3F9FF" text-color="#728FC4">{{item.label.name}}</van-tag><span class="posttitle">{{ item.title }}</span>
                  </h3>
                  <div class="sourtime mt-10"><i v-if="item.media!=null">{{item.media.name}}</i></div>
                </van-col>
              </van-row>
            </div>
          </div>
          <div v-if="item.module.id==2">
            <div class="topichei" v-if="item.topic_info.id&&params.media_column_id>0" @click="binTopic(item.topic_info.id)">
              <img  class="topicpic" :src="item.topic_info.pic_url">
              <div class="picount">
                <div class="f-14">话题</div>
                <van-divider />
                <div class="f-16 mt-10 f-w">#{{item.topic_info.name}}#</div>
              </div>
            </div>
            <div v-if="item.topic_info.length==0">
              <h3 @click="lexusPost(2,item.id)" class="listitle leftright"><van-tag class="mr-10" v-if="item.label!=null" color="#F3F9FF" text-color="#728FC4">{{item.label.name}}</van-tag><span class="posttitle">{{ item.title }}</span>
              </h3>
              <div class="pic" @click="ImgPreview(item.id)">
                <img v-if="item.pics && item.pics[0]" v-lazy="item.pics[0].img_url" :alt="item.title" />
                <img class="picenter" :src="img.picture">
              </div>
              <span class="sourtime leftright"><i v-if="item.media!=null">{{item.media.name}}</i><!-- {{item.time_format}} --></span>
            </div>
          </div>
        </div>
        <div class="list-box" v-if="item.topic_info&&params.media_column_id>0">

          <div v-if="item.module.id==1">
            <div class="topichei" v-if="item.topic_info.id&&params.media_column_id>0" @click="binTopic(item.topic_info.id)">
              <img  class="topicpic" :src="item.topic_info.pic_url">
              <div class="picount">
                <div class="f-14">话题</div>
                <van-divider />
                <div class="f-16 mt-10 f-w">#{{item.topic_info.name}}#</div>
              </div>
            </div>
            <div class="leftright">

              <van-row gutter="20" v-if="item.topic_info.length==0" @click="lexusPost(1,item.id)">
                <van-col span="10">
                  <img class="picone" v-lazy="item.pic_url">
                </van-col>
                <van-col span="14" >
                  <h3 class="ellipsis-3"><van-tag class="mr-10" v-if="item.label!=null" color="#F3F9FF" text-color="#728FC4">{{item.label.name}}</van-tag><span class="posttitle">{{ item.title }}</span>
                  </h3>
                  <div class="sourtime mt-10"><i v-if="item.media!=null">{{item.media.name}}</i></div>
                </van-col>
              </van-row>
            </div>
          </div>
          <div v-if="item.module.id==2">
            <div class="topichei" v-if="item.topic_info.id&&params.media_column_id>0" @click="binTopic(item.topic_info.id)">
              <img  class="topicpic" :src="item.topic_info.pic_url">
              <div class="picount">
                <div class="f-14">话题</div>
                <van-divider />
                <div class="f-16 mt-10 f-w">#{{item.topic_info.name}}#</div>
              </div>
            </div>
            <div v-if="item.topic_info.length==0">
              <h3 @click="lexusPost(2,item.id)" class="listitle leftright"><van-tag class="mr-10" v-if="item.label!=null" color="#F3F9FF" text-color="#728FC4">{{item.label.name}}</van-tag><span class="posttitle">{{ item.title }}</span>
              </h3>
              <div class="pic" @click="ImgPreview(item.id)">
                <img v-if="item.pics && item.pics[0]" v-lazy="item.pics[0].img_url" :alt="item.title" />
                <img class="picenter" :src="img.picture">
              </div>
              <span class="sourtime leftright"><i v-if="item.media!=null">{{item.media.name}}</i><!-- {{item.time_format}} --></span>
            </div>
          </div>
        </div>
      </div>
    </van-list>
  </van-pull-refresh>
  <van-image-preview
  v-model="showState"
  :images="images"
  lazyLoad
  @change="changeImg"
  @close="close"
  >
  <template v-slot:index>
    {{ imgIndex + 1 }}/{{ images.length }}
    <h5>{{ titles[imgIndex] }}</h5>
  </template>
</van-image-preview>
<van-popup v-model="show" @close="close"
:style="{ top: '13%',width:'30%','text-align':'center','left':'82%' }">
<div class="triangle"></div>
<div class="popback">
  <van-cell title="写动态" @click="goPost(1)" :icon="img.dynamic" />
      <!-- <van-cell title="图片" @click="goPost(2)" :icon="img.pictur" />
        <van-cell title="视频" @click="goPost(3)" :icon="img.video" /> -->
        <van-cell title="提问" @click="goPost(4)" :icon="img.ask" />
      </div>
    </van-popup>
    <div class="totopbox" @click="toTop" v-if="scroll">
      <img class="totop" :src="img.totop">
    </div>
  </div>
</template>
<script>
  import list from '../../../api/content';
  import member from '../../../api/member/memberinfo';
  import common from '../../../api/common';
  import { mapState } from 'vuex';
  import { Tab, Tabs,Row, Col, Tag,List,NavBar,Popup,Cell, CellGroup,Icon,PullRefresh,Divider,Sticky,ImagePreview} from 'vant';
  export default {
    data () {
      return {
        media_column_index:0,
        params: {
          media_id:6,
          media_column_id:0,
          page: 1,
          user_id: 0
        },
        paramsc:{
          media_id:6
        },
        list: [],
        loading: false,
        finished: false,
        channel: [{
          "id": 0,
          "title": "全部"
        }],
        active:0,
        show:false,
        images:[],
        imgIndex:0,
        showState:false,
        top_margin: 0,
        scroll:false,
        isLoading:false,
        sicky_Height:38,
        img: {
          parise: require('../../../assets/img/parise.png'),
          parise_have: require('../../../assets/img/parise_have.png'),
          comment: require('../../../assets/img/comment.png'),
          loading: require('../../../assets/img/loading_lexus.gif'),
          avatar: require('../../../assets/img/lexus/default.png'),
          write: require('../../../assets/img/lexus/write-black.png'),
          navstudy: require('../../../assets/img/lexus/navstudy.png'),
          picture:require('../../../assets/img/lexus/picture.png'),
          dynamic:require('../../../assets/img/lexus/dynamic.png'),
          pictur:require('../../../assets/img/lexus/pictur.png'),
          video:require('../../../assets/img/lexus/video.png'),
          ask:require('../../../assets/img/lexus/ask.png'),
          totop: require('../../../assets/img/lexus/totop.png'),
          lexus:require('../../../assets/img/lexus/lexus.png'),
          wear:require('../../../assets/img/lexus/wear.png'),
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.getChannel()
      this.getMyInfo()
      this.weburl=process.env.VUE_APP_URL
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        }
      })
      var params={
        event_code: '阅',
        event_id: '',
        title: '',
        value: '',
        path: '/Lexus/Content/Index.vue',
        user_id: this.user ? this.user.id : 0,
        source: this.source
      }
      common.BurialPoint(params).then(res => {
        if(res.data.state==1){
        }
      })
    },
    activated () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: false})
      this.$appService.getWinHeight(v => {
        console.log('getWinHeight=='+v.height)
        this.top_margin = 0
      })
      this.$appService.isTabbar({state: false})
      this.sicky_Height = this.$refs.container.offsetHeight;
    },
    // mounted () {
    //   window.addEventListener('scroll', this.scrollToTop)
    // },
    methods: {
      getChannel(){
        list.getChannel(this.paramsc).then(res => {
          if(res.data.state == 1) {
            this.channel.push.apply(this.channel, res.data.data)
          }
        })
      },
      changeChannel(e){
        var index=e
        this.media_column_index=index
        var channel=this.channel
        this.params.media_column_id=channel[index].id
        this.params.page = 1;
        this.list = [];
        if(this.finished){
          this.finished=false
        }else{
          this.onLoad();
        }
      },
      PopupShow(){
        this.$appService.isTabbar({state: true})
        this.show=true
      },
      scrollToTop() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        if(scrollTop>224){
          this.scroll=true
        }else{
          this.scroll=false
        }
      },
      toTop(){
        scrollTo(0,0);
        this.scroll=false
      },
      goPost(type){
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
            var params={
              type:type
            }
            this.show=false
            this.$appService.goPost(params)
          } else {
            var params={
              pagetype:1,
              type:type
            }
            this.$appService.needLogin(params)
          }
        })
      },
      binTopic(id){
        var params={
          url:this.weburl+'/lexus/topicinfo/'+id+'?source='+this.source,
          isReturn: true 
        }
        this.$appService.openWebView(params)
      },
      onRefresh() {
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
          }
        })
        this.isLoading = false;
        this.getMyInfo()
      },
      getMyInfo(){
       var luser=JSON.parse(localStorage.getItem("user"))
       if(luser){
        var id=luser.data.id
        member.getMyInfo(id).then(res => {
          if(res.data.state==1){
            var info=res.data.data
            this.user.avatar=info.avatar
          }
        })
      }
    },
    onLoad() {
        // 异步更新数据
        setTimeout(() => {
          list.getList(this.params).then(res => {
            this.list.push.apply(this.list, res.data.data)
            this.params.page += 1
            this.loading = false

            if(res.data.data.length == 0) {
              this.finished = true
            }
          })
        }, 500);
      },
      goMy(){
        this.$appService.getToken(v => {
          if(v.token) {
            var params={
              url:this.weburl+'/lexus/my?source='+this.source ,
              isReturn: true 
            }
            this.$appService.openWebView(params)
          }else{
            var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
            // var params={
            //   url:this.weburl+'/lexus/my',
            //   pagetype:2,
            //   isReturn: true 
            // }
            // this.$appService.needLogin(params)
          }
        })

      },
      lexusPost(type,id){
        var params={
          url:'' ,
          isReturn: true,
          url:this.weburl+'/lexus/article/'+id+'/post'+'?source='+this.source
        }
        // if(type==1){
        //   params.url=this.weburl+'/lexus/article/'+id+'/post'+'?source='+this.source
        // }else{
        //   params.url=this.weburl+'/lexus/article/'+id+'/pic'+'?source='+this.source
        // }
        this.$appService.openWebView(params)
      },
      ImgPreview(id){
        list.getShow(id).then(res => {
          if(res.data.state == 1) {
            this.info = res.data.data
            this.$util.title(res.data.data.title)
            var apppar={
              title:res.data.data.title
            }
            this.$appService.changeTitle(apppar)
            this.images = []
            this.titles = []
            for(let i of res.data.data.all_pics) {
              this.images.push(i.img_url)
              this.titles.push(i.title)
            }
            this.$appService.isTabbar({state: true})
            this.showState = true
          }
        })
      },
      close(){
        this.show=false
        this.showState=false
        this.$appService.isTabbar({state: false})
      },
      changeImg (index) {
        this.imgIndex = index
      },
    },
    components: {
      [Row.name]: Row,
      [Col.name]: Col,
      [List.name]: List,
      [Tag.name]: Tag,
      [Tab.name]:Tab,
      [Tabs.name]:Tabs,
      [NavBar.name]:NavBar,
      [Popup.name]:Popup,
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [Icon.name]: Icon,
      [Divider.name]:Divider,
      [PullRefresh.name]:PullRefresh,
      [Sticky.name]:Sticky,
      [ImagePreview.name]:ImagePreview
    }
  }
</script>
<style lang="scss">
  .content{
    /*margin-top: 72px;*/
    background-color: transparent;
    [class*=van-hairline]::after{
      border-top: 0 solid #ebedf0;
    }
    .van-popup{
      background-color: transparent;
    }
    .popback{
      background-color: #5F5B6B;
      margin-top: 10px;
      .van-cell:not(:last-child)::after{
        right: 10px;
      }
    }
    .triangle{
      width:0;
      height:0;
      border-right:10px solid transparent;
      border-left:10px solid transparent;
      border-bottom:10px solid #5F5B6B;
      float: right;
      margin-right: 5px;
    }
    .van-nav-bar{
      z-index: 999;
      position: fixed;
      top: 0;
      width: 100%;
      .van-nav-bar__left{
        top: 10px;
        .homemem{
          width:30px;
          height:30px;
          object-fit: cover;
        }
      }
      .van-nav-bar__title{
        .navbartitle{
          margin-top: 10px;
          width: 30px;
          height: 27px;
        }
      }
      .van-nav-bar__right{
        top: 5px;
        .homewrite{
          width: 20px;
        }
      }
    }
    .imgwear{
      position:fixed;
      right: 0;
      height: 38px;
    }
    .swipe-img{
      width: 100%;
      height: 225px;
      display: block;
      object-fit: cover;
    }
    .list-box{
      padding: 12px 0;
      border-bottom: 1px solid #EAEAEA;
      .leftright{
        padding: 0 10px;
      }
      a {
        padding: 0;
        color: #3A3A3A;
      }
      .picone{
        width:150px;
        height:100px;
        display: block;
        object-fit: cover;
      }
      .ellipsis-3{
        height: 75px;
      }
      h3 {
        font-size: 15px;
        margin: 0;
      }
      .listitle{
        margin-bottom: 15px;
      }
      .posttitle{
        vertical-align: middle;
      }
      .van-tag {
        font-weight: normal;
        margin-right: 10px;
        font-size: 10px;
      }
      .mt-10{
        margin-top: 10px;
      }
      .sourtime{
        font-size: 12px;
        color: #9A9A9A;

        i {
          font-style: normal;
          padding-right: 10px;
        }
      }
      .binpic{
        width:15px;
        height:14px;
        margin-right: 10px;
        vertical-align: middle;
      }
      .bintright{
        text-align:right;
      }
      .binbox{
        margin-left:28px;
      }
      .pic {
        .picenter{
          width: 25px;
          height: 25px;
          float: right;
          margin-right: 10px;
          margin-top: -35px;
          position: relative;
        }
        img {
          width: 100%;
          height: 260px;
          object-fit: cover;
          display: block;
          &.right {
            height: 100px;
          }
          &.one {
            margin-bottom: 5px;
          }
        }
      }
      .topichei{
        height: 240px;
      }
      .topicpic{
        width: 100%;
        height: 240px;
        object-fit: cover;
      }
      .picount{
        color: #fff;
        margin-top: -35%;
        padding: 10px;
        position: absolute;
        .mt-10{
          margin-top: 10px;
        }
        .van-divider{
          width: 105px;
          border-color: #fff;
        }
      }
      .topcheight{
        padding: 16px;
      }
    }
    .van-popup{
      background-color: transparent;
      .van-cell{
        background-color: #5F5B6B;
        color: #fff;
      }
      .popback{
        background-color: #5F5B6B;
        margin-top: 10px;
      }
      .triangle{
        width:0;
        height:0;
        border-right:10px solid transparent;
        border-left:10px solid transparent;
        border-bottom:10px solid #5F5B6B;
        float: right;
        margin-right: 5px;
      }
    }
    .van-image-preview__index {
      top: 80%;
      left: 30px;

      h5 {
        font-weight: normal;
      }
    }
  }
</style>